import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import './Location.css';

const Location = () => {
  return (
    <section id="location" className="location-section section-padding">
      <div className="container">
        <motion.div
          className="location-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-1">Find Your Peace</h2>
          <p className="body-large">Amidst the serene hills</p>
        </motion.div>

        <motion.div
          className="location-content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="map-container">
           <iframe
  title="Location Map"
  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3467.264053885828!2d79.6633611!3d29.6541111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjnCsDM5JzE0LjgiTiA3OcKwMzknNDguMSJF!5e0!3m2!1sen!2sin!4v1763575937812!5m2!1sen!2sin&forceReload=1"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

          </div>

          <div className="location-details">
            <div className="detail-item">
              <MapPin size={20} />
              <div>
                <h3 className="heading-3">The Heaven Town Homestay</h3>
                <p className="body-regular">Gadholi,Almora,Uttarakhand</p>
                <p className="body-small">Open daily from 8:00 AM to 10:00 PM</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Location;
